import ServerGridConfig from "../../../../../config/ServerGridConfig";
import { AgGridReact } from "@ag-grid-community/react";
import { AllModules } from "@ag-grid-enterprise/all-modules";
import useStore from "../../../../../store";
import { observer } from "mobx-react";
import { vsmCommon } from "../../../../../config/messages";
import { Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faReply } from "@fortawesome/free-solid-svg-icons";
import { DateComparator } from "../../../../../utils/GlobalFunction";

const ActionRenderer = observer((props) => {
	const { AUTH } = useStore();
	const {
		openViewModal,
		openRevertModal,
	} = props.agGridReact.props.frameworkComponents
	return (
		<div className="action-column">
			{AUTH.checkPrivileges("#8245#") && (
				<Button
					type="text"
					title={"View"}
					className="viewIcon mr-10"
					size="large"
					style={{ padding: 7 }}
					onClick={() => {
						openViewModal(props.data);
					}}
				>
					<FontAwesomeIcon icon={faEye} />
				</Button>
			)}
			{(AUTH.checkPrivileges("#8246#")) && (
				<Button
					type="text"
					title={"Revert"}
					className="viewIcon"
					size="large"
					style={{ padding: 7 }}
					onClick={() => {
						openRevertModal(props.data);
					}}
				>
					<FontAwesomeIcon icon={faReply} />
				</Button>
			)}

		</div>
	);
});

const ListComponent = observer((props) => {
	const {
		openViewModal,
		openRevertModal
	} = props;
	const {
		ReadyForDelivery: { list_data, setupGrid, } } = useStore();

	const gridOptions = {
		columnDefs: [
			{
				headerName: "Z-Form",
				field: "id",
				filter: "agNumberColumnFilter",
				pinned: "left",
				minWidth: 120,
				width: 120,
			},
			{
				headerName: "CO NO",
				field: "co_no",
			},
			{
				headerName: "Date",
				field: "date",
				filter: "agDateColumnFilter",
				filterParams: {
					buttons: ['reset'],
					inRangeInclusive: true,
					suppressAndOrCondition: true,
					comparator: DateComparator
				}
			},
			{
				headerName: "Date Completed",
				field: "date_completed",
				filter: "agDateColumnFilter",
				filterParams: {
					buttons: ['reset'],
					inRangeInclusive: true,
					suppressAndOrCondition: true,
				},
			},
			{
				headerName: "Customer",
				field: "booking_customer.full_name",
			},
			{
				headerName: "Location Name",
				field: "location.name",
				valueGetter: (params) => (params.data && params.data.location) ? params.data.location?.name : "N/A",
			},
			{
				headerName: "Model",
				field: "booking_model.model.name",
			},
			{
				headerName: "Variant",
				field: "booking_model.variant.name",
			},
			{
				headerName: "Customer Type",
				field: "booking_customer.customer_type.name",
			},
			{
				headerName: "Consultant",
				field: "sales_consultant.name",
			},
			{
				headerName: "Package Name",
				field: "package_offer.package.name",
				valueGetter: (params) => (params.data && params.data.package_offer?.package) ? params.data.package_offer?.package?.name : "N/A",
			},
			{
				headerName: "Company Name",
				field: "corporate_offer.approved_company.name",
				valueGetter: (params) => (params.data && params.data.corporate_offer?.approved_company?.name) ? params.data.corporate_offer?.approved_company?.name : "N/A",
			},
			{
				headerName: "Chassis No",
				field: "booking_model.chassis_no",
				valueGetter: (params) => (params.data && params.data.booking_model.chassis_no) ? params.data.booking_model.chassis_no : "N/A",
			},
			{
				headerName: "Total Credits",
				field: "booking_ledger.total_credits",
				filter: "agNumberColumnFilter",
			},
			{
				headerName: "Invoice NO",
				field: "inv_no",
				initialHide: true
			},
			{
				headerName: "Invoice Date",
				field: "inv_date_changed",
				filter: "agDateColumnFilter",
				initialHide: true
			},
			
			{
				headerName: "Color",
				field: "booking_model.color.name",
				initialHide: true
			},
			{
				headerName: "Delivery Date",
				field: "booking_model.promised_delivery_date_changed",
				filter: "agDateColumnFilter",
				initialHide: true
			},
			{
				headerName: "Completed (%)",
				field: "dc_per",
				filter: "agNumberColumnFilter",
				initialHide: true
			},		
			{
				headerName: "Actions",
				field: "actions",
				type: "actionColumn",
				filter: false,
				sortable: false,
				pinned: "right",
				minWidth: 120,
				width: 120,
			},
		],
	};
	return (
		<div className="ag-theme-alpine grid_wrapper">
			<AgGridReact
				rowHeight={ServerGridConfig.rowHeight}
				headerHeight={ServerGridConfig.headerHeight}
				rowData={list_data}
				modules={AllModules}
				columnDefs={gridOptions.columnDefs}
				defaultColDef={ServerGridConfig.defaultColDef}
				columnTypes={ServerGridConfig.columnTypes}
				overlayNoRowsTemplate={vsmCommon.noRecord}
				frameworkComponents={{
					ActionRenderer,
					openViewModal,
					openRevertModal
				}}
				onGridReady={setupGrid}
				gridOptions={ServerGridConfig.options}
			/>
		</div>
	);
});

export default ListComponent;
